import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import {
  AllowTakeOverPatientFileLockInput,
  useAllowTakeOverPatientMutation as useAllowTakeOverPatientMutationType,
} from "@/modules/patients/services/__generated__/useAllowTakeOverPatientMutation.graphql"

const allowTakeOverPatientMutation = graphql`
  mutation useAllowTakeOverPatientMutation($input: AllowTakeOverPatientFileLockInput!) {
    allowTakeOverPatientFileLock(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      patientFileLockOutput {
        ...PatientFileLockOutputFragment
      }
    }
  }
`

const useAllowTakeOverPatientMutation = () => {
  const [commit] = useMutation<useAllowTakeOverPatientMutationType>(allowTakeOverPatientMutation)

  return useCallback(
    (input: AllowTakeOverPatientFileLockInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.allowTakeOverPatientFileLock
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}

export { useAllowTakeOverPatientMutation }
